import { ReactElement } from "react";
import { className } from "../../../shared/helpers";
import { useTimeMachine, useTimeMachineUpdate } from "../../../contexts/TimeMachineContext";
import useWindowWidth from "../../../hooks/UseWindowWidth";
import TimeTravelControls from "./TimeTravelControls";
import styles from "./TimeMachine.module.scss";

const TimeMachine = (): ReactElement =>
{
    const timeMachine = useTimeMachine();
    const timeMachineUpdate = useTimeMachineUpdate();
    const isDesktop = useWindowWidth(992);


    const getDaySuffix = (day: number): string =>
    {
        switch (day)
        {
            case 1: case 21: case 31: return "st";
            case 2: case 22: return "nd";
            case 3: case 23: return "rd";
            default: return "th";
        }
    }

    const getDateString = (): string =>
    {
        if (isDesktop)
        {
            const day = timeMachine.getDate();
            const weekday = timeMachine.toLocaleString("en-us", { weekday: "long" });
            const month = timeMachine.toLocaleString("en-us", { month: "long" });
            const suffix = getDaySuffix(day);
            return `${weekday}, ${day + suffix} ${month}`;
        }
        else
        {
            const day = String(timeMachine.getDate()).padStart(2, "0");
            const month = String(timeMachine.getMonth()).padStart(2, "0");
            const year = timeMachine.getFullYear();
            return `${month}/${day}/${year}`
        }
    }

    const getTimeString = (): string =>
    {
        const hours = String(timeMachine.getHours()).padStart(2, "0");
        const minutes = String(timeMachine.getMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
    }

    return (
        <div {...className(
            styles.timemachine,
            { [styles.active]: timeMachine }
        )}>
            <span className={styles.title}>
                {timeMachine
                    ? `${getDateString()} - ${getTimeString()}`
                    : "Time Machine"
                }

                {timeMachine && <span className={styles.badge}>Active</span>}
            </span>

            {timeMachine
                ? <TimeTravelControls />
                : <button className={styles.btn} onClick={() => timeMachineUpdate(new Date())}>START</button>
            }
        </div>
    );
};

export default TimeMachine;
